export default "__VITE_ASSET__Ct8QTE4V__"